/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { Observable, Subscription } from "rxjs";

let messages$: Observable<HTMLElement> | null = null;

const setMessagesObservable = (target: HTMLElement) => {
  messages$ = new Observable((subscriber) => {
    const observer = new MutationObserver(() => subscriber.next());

    observer.observe(target, {
      childList: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
    };
  });
};

@Component({
  selector: "message-group",
  templateUrl: "./message-group.component.html",
  host: {
    class: "ds-relative ds-px ds-py-xs ds-rounded-lg ds-ml-2xl ds-max-w-[75%] ds-min-w-[50%] ds-mb-sm",
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageGroupComponent implements OnInit, OnDestroy {
  @Input() alignment: "left" | "right" = "left";
  @Input() icon: "agent" | "bot" | "warning" | null = null;

  isFirst = true;
  isLast = true;

  private _messagesSubscription = Subscription.EMPTY;

  @HostBinding("class.ds-rounded-tr-none") get noRoundedTopRightCorner() {
    return !this.isFirst && this.alignment === "right";
  }
  @HostBinding("class.ds-rounded-br-none") get noRoundedBottomRightCorner() {
    return !this.isLast && this.alignment === "right";
  }
  @HostBinding("class.ds-rounded-bl-none") get noRoundedBottomLeftCorner() {
    return !this.isLast && this.alignment === "left";
  }
  @HostBinding("class.ds-rounded-tl-none") get noRoundedTopLeftCorner() {
    return !this.isFirst && this.alignment === "left";
  }
  @HostBinding("class.!ds-mb-2xs") get condensedMargin() {
    return !this.isLast;
  }
  @HostBinding("class.ds-self-end") get alignRight() {
    return this.alignment === "right";
  }
  @HostBinding("class.ds-self-start") get alignLeft() {
    return this.alignment === "left";
  }

  constructor(private elementRef: ElementRef<HTMLElement>, private changeDetectorRef: ChangeDetectorRef) {}

  ngOnInit() {
    if (!messages$) {
      setMessagesObservable(this.elementRef.nativeElement.closest<HTMLElement>("#chat-app-messages-wrapper")!);
    }
    this._messagesSubscription = messages$!.subscribe(() => {
      const hostElement = this.elementRef.nativeElement.parentElement!.parentElement!;
      const nextElement = hostElement.nextElementSibling;
      const previousElement = hostElement.previousElementSibling;
      this.isFirst = hostElement.tagName !== previousElement?.tagName;
      this.isLast = hostElement.tagName !== nextElement?.tagName;
      this.changeDetectorRef.markForCheck();
    });
  }

  ngOnDestroy() {
    this._messagesSubscription.unsubscribe();
  }
}
